// bsc Mainnet
export const BSC_CHAIN_PARAMS = [
  {
    chainId: '0x38', // 56 in decimal
    chainName: 'Binance Smart Chain Mainnet',
    rpcUrls: ['https://bsc-dataseed1.binance.org'],
    nativeCurrency: {
      name: 'Binance Coin',
      symbol: 'BNB',
      decimals: 18
    },
    blockExplorerUrls: ['https://bscscan.com']
  }
];

let gChainParams = [
  // {
  //   chainId: '0x61', // 56 in decimal
  //   chainName: 'Binance Smart Chain - Testnet',
  //   rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545'],
  //   nativeCurrency: {
  //     name: 'Binance Coin',
  //     symbol: 'BNB',
  //     decimals: 18
  //   },
  //   blockExplorerUrls: ['https://testnet.bscscan.com']
  // }
];

let MH_NFT_ADDRESS = '0xDAaAEa8d9716f9D9B182295E3D591023DcB8f219'; // BSC Test HERO contract
// export const MH_NFT_ADDRESS = '0xe89fE993a81142188a9A2BF3FD24425720049d3D'; // local HERO contract
export const MH_NFT_ABI = [
  {
    inputs: [
      {
        internalType: 'contract IMiracleGameSC',
        name: 'sc',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'o',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'm',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_approved',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_operator',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: '_approved',
        type: 'bool'
      }
    ],
    name: 'ApprovalForAll',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    inputs: [],
    name: 'CANNOT_TRANSFER_TO_ZERO_ADDRESS',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'NOT_CURRENT_OWNER',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_approved',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'baseURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'getApproved',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getMinter',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getOwner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      }
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: '_user',
        type: 'address'
      }
    ],
    name: 'isOwnerOf',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256[]',
        name: '_tokenId',
        type: 'uint256[]'
      },
      {
        internalType: 'address',
        name: '_user',
        type: 'address'
      }
    ],
    name: 'isOwnerOf',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'maxSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'mintMulti',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'ownerOf',
    outputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes'
      }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: '_approved',
        type: 'bool'
      }
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '_uri',
        type: 'string'
      }
    ],
    name: 'setBaseURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_maxSupply',
        type: 'uint256'
      }
    ],
    name: 'setMaxSupply',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'addr',
        type: 'address'
      }
    ],
    name: 'setMinter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'addr',
        type: 'address'
      }
    ],
    name: 'setOwner',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      },
      {
        internalType: 'string',
        name: '_uri',
        type: 'string'
      }
    ],
    name: 'setTokenURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: '_interfaceID',
        type: 'bytes4'
      }
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_index',
        type: 'uint256'
      }
    ],
    name: 'tokenByIndex',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_index',
        type: 'uint256'
      }
    ],
    name: 'tokenOfOwnerByIndex',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_page',
        type: 'uint256'
      }
    ],
    name: 'tokenOfOwnerByPage',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'tokenURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
];

let MBB_NFT_ADDRESS = '0x9038eC8F96F80641e667f37159ac5946d03Fb1f9'; // BSC Test MBB contract
// export const MBB_NFT_ADDRESS = '0xDAaAEa8d9716f9D9B182295E3D591023DcB8f219'; // local MBB contract
export const MBB_NFT_ABI = [
  {
    inputs: [
      {
        internalType: 'contract IMiracleGameSC',
        name: 'sc',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'o',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'ApprovalForAll',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]'
      }
    ],
    name: 'TransferBatch',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'TransferSingle',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'value',
        type: 'string'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'URI',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      }
    ],
    name: 'balanceOfBatch',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getOwner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      }
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'addr',
        type: 'address'
      }
    ],
    name: 'setOwner',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4'
      }
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'uri',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

let MG_TOKEN_ADDRESS = '0xbF8a8470D4ADB2bffB7f8494E21e41144c6dc8B7'; // BSC Test MG contract
// export const MG_TOKEN_ADDRESS = '0x47B622514f496a1DF098E8B7902532A4661b1a8F'; // local MG contract
export const MG_TOKEN_ABI = [
  {
    inputs: [
      {
        internalType: 'contract IMiracleGameSC',
        name: 'sc',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'o',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: 'remaining',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: 'success',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: 'balance',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getOwner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      }
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    name: 'otaKey',
    outputs: [
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      }
    ],
    name: 'otabalanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: 'balance',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        internalType: 'bytes',
        name: '_toKey',
        type: 'bytes'
      },
      {
        internalType: 'uint256',
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'otatransfer',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    name: 'privacyBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'addr',
        type: 'address'
      }
    ],
    name: 'setOwner',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: 'success',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_value',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: 'success',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
];

let MARKET_ADDRESS = '0xDC3120076c64dba4B937A84545b4A383db71D7aE'; // BSC Test MARKET contract
// export const MARKET_ADDRESS = '0xb3604bDd619525b90495b894Ac33Ba3bC74C937A'; // local MARKET contract
export const MARKET_ABI = [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_owner",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			}
		],
		"name": "AuctionCancelled",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "scType",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "scFlag",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "feeFlag",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "seller",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "price",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "expiresAt",
				"type": "uint256"
			}
		],
		"name": "AuctionCreated",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			}
		],
		"name": "AuctionExecuted",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "legacyNFTAddress",
				"type": "address"
			}
		],
		"name": "ChangeLegacyNFTAddress",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "ownerCutPerMillion",
				"type": "uint256"
			}
		],
		"name": "ChangedOwnerCutPerMillion",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "publicationFee",
				"type": "uint256"
			}
		],
		"name": "ChangedPublicationFee",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "Paused",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "Unpaused",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			}
		],
		"name": "auctionByOrderId",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint8",
						"name": "status",
						"type": "uint8"
					},
					{
						"internalType": "uint256",
						"name": "orderId",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "scType",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "scFlag",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "feeFlag",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "seller",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "expiresAt",
						"type": "uint256"
					}
				],
				"internalType": "struct MarketplaceStorage.Order",
				"name": "",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256[]",
				"name": "orderIds",
				"type": "uint256[]"
			}
		],
		"name": "auctionByOrderIds",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint8",
						"name": "status",
						"type": "uint8"
					},
					{
						"internalType": "uint256",
						"name": "orderId",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "scType",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "scFlag",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "feeFlag",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "seller",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "expiresAt",
						"type": "uint256"
					}
				],
				"internalType": "struct MarketplaceStorage.Order[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ts",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			}
		],
		"name": "cancel1155Order",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ts",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			}
		],
		"name": "cancel721Order",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ts",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "scFlag",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "feeFlag",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "price",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "expiresAt",
				"type": "uint256"
			}
		],
		"name": "create1155Order",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ts",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "scFlag",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "feeFlag",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "price",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "expiresAt",
				"type": "uint256"
			}
		],
		"name": "create721Order",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ts",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			}
		],
		"name": "execute1155Order",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "ts",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "orderId",
				"type": "uint256"
			}
		],
		"name": "execute721Order",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "flag",
				"type": "uint256"
			}
		],
		"name": "getBep1155",
		"outputs": [
			{
				"internalType": "contract Bep1155",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "flag",
				"type": "uint256"
			}
		],
		"name": "getBep20",
		"outputs": [
			{
				"internalType": "contract Bep20",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint8",
				"name": "flag",
				"type": "uint8"
			}
		],
		"name": "getBep721",
		"outputs": [
			{
				"internalType": "contract Bep721",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "uint256[]",
				"name": "",
				"type": "uint256[]"
			},
			{
				"internalType": "uint256[]",
				"name": "",
				"type": "uint256[]"
			},
			{
				"internalType": "bytes",
				"name": "",
				"type": "bytes"
			}
		],
		"name": "onERC1155BatchReceived",
		"outputs": [
			{
				"internalType": "bytes4",
				"name": "",
				"type": "bytes4"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "bytes",
				"name": "",
				"type": "bytes"
			}
		],
		"name": "onERC1155Received",
		"outputs": [
			{
				"internalType": "bytes4",
				"name": "",
				"type": "bytes4"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "ownerCutPerMillion",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "pause",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "paused",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "publicationFeeInWei",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "flag",
				"type": "uint256"
			},
			{
				"internalType": "contract Bep1155",
				"name": "sc",
				"type": "address"
			}
		],
		"name": "setBep1155",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "flag",
				"type": "uint256"
			},
			{
				"internalType": "contract Bep20",
				"name": "sc",
				"type": "address"
			}
		],
		"name": "setBep20",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint8",
				"name": "flag",
				"type": "uint8"
			},
			{
				"internalType": "contract Bep721",
				"name": "sc",
				"type": "address"
			}
		],
		"name": "setBep721",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_ownerCutPerMillion",
				"type": "uint256"
			}
		],
		"name": "setOwnerCutPerMillion",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_publicationFee",
				"type": "uint256"
			}
		],
		"name": "setPublicationFee",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes4",
				"name": "",
				"type": "bytes4"
			}
		],
		"name": "supportsInterface",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "unpause",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
];

let MU_ADDRESS = '';
export const MU_ABI = [
    {
        "inputs":[
            {
                "internalType":"contract IMiracleGameSC",
                "name":"sc",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"o",
                "type":"address"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"constructor"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"_owner",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"_spender",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint256",
                "name":"_value",
                "type":"uint256"
            }
        ],
        "name":"Approval",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"_owner",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"_operator",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"bool",
                "name":"_approved",
                "type":"bool"
            }
        ],
        "name":"ApprovalForAll",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"_from",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"_to",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint256",
                "name":"_value",
                "type":"uint256"
            }
        ],
        "name":"Transfer",
        "type":"event"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"_owner",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"_spender",
                "type":"address"
            }
        ],
        "name":"allowance",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"remaining",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"_spender",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"_value",
                "type":"uint256"
            }
        ],
        "name":"approve",
        "outputs":[
            {
                "internalType":"bool",
                "name":"success",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"_owner",
                "type":"address"
            }
        ],
        "name":"balanceOf",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"balance",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"decimals",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"getOwner",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"account",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"operator",
                "type":"address"
            }
        ],
        "name":"isApprovedForAll",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"name",
        "outputs":[
            {
                "internalType":"string",
                "name":"",
                "type":"string"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "name":"otaKey",
        "outputs":[
            {
                "internalType":"bytes",
                "name":"",
                "type":"bytes"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"_owner",
                "type":"address"
            }
        ],
        "name":"otabalanceOf",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"balance",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"_to",
                "type":"address"
            },
            {
                "internalType":"bytes",
                "name":"_toKey",
                "type":"bytes"
            },
            {
                "internalType":"uint256",
                "name":"_value",
                "type":"uint256"
            }
        ],
        "name":"otatransfer",
        "outputs":[
            {
                "internalType":"string",
                "name":"",
                "type":"string"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "name":"privacyBalance",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"operator",
                "type":"address"
            },
            {
                "internalType":"bool",
                "name":"approved",
                "type":"bool"
            }
        ],
        "name":"setApprovalForAll",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"addr",
                "type":"address"
            }
        ],
        "name":"setOwner",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"symbol",
        "outputs":[
            {
                "internalType":"string",
                "name":"",
                "type":"string"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"totalSupply",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"_to",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"_value",
                "type":"uint256"
            }
        ],
        "name":"transfer",
        "outputs":[
            {
                "internalType":"bool",
                "name":"success",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"_from",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"_to",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"_value",
                "type":"uint256"
            }
        ],
        "name":"transferFrom",
        "outputs":[
            {
                "internalType":"bool",
                "name":"success",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    }
];

let GAME_ADDRESS = '';
export const GAME_ABI = [
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"o",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"v",
                "type":"address"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"constructor"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":false,
                "internalType":"address",
                "name":"sender",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "indexed":false,
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "indexed":false,
                "internalType":"uint32",
                "name":"itemId",
                "type":"uint32"
            },
            {
                "indexed":false,
                "internalType":"uint64",
                "name":"itemNum",
                "type":"uint64"
            }
        ],
        "name":"eventItemToToken1155",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":false,
                "internalType":"address",
                "name":"sender",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "indexed":false,
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "indexed":false,
                "internalType":"uint64",
                "name":"amount",
                "type":"uint64"
            }
        ],
        "name":"eventItemToToken20",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":false,
                "internalType":"address",
                "name":"sender",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "indexed":false,
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "indexed":false,
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            }
        ],
        "name":"eventItemToToken721",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":false,
                "internalType":"address",
                "name":"sender",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "indexed":false,
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "indexed":false,
                "internalType":"uint32",
                "name":"itemId",
                "type":"uint32"
            },
            {
                "indexed":false,
                "internalType":"uint64",
                "name":"itemNum",
                "type":"uint64"
            }
        ],
        "name":"eventToken1155ToItem",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":false,
                "internalType":"address",
                "name":"sender",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "indexed":false,
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "indexed":false,
                "internalType":"uint64",
                "name":"amount",
                "type":"uint64"
            }
        ],
        "name":"eventToken20ToItem",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":false,
                "internalType":"address",
                "name":"sender",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "indexed":false,
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "indexed":false,
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            }
        ],
        "name":"eventToken721ToItem",
        "type":"event"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            }
        ],
        "name":"getBep1155",
        "outputs":[
            {
                "internalType":"contract Bep1155",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            }
        ],
        "name":"getBep20",
        "outputs":[
            {
                "internalType":"address[]",
                "name":"ret",
                "type":"address[]"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            }
        ],
        "name":"getBep721",
        "outputs":[
            {
                "internalType":"contract Bep721",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"getOwner",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"getTransTimeout",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"getVerifier",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToMa",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32",
                "name":"itemId",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"itemNum",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToMab",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32",
                "name":"itemId",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"itemNum",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToMbb",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"amount",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToMg",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToMh",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToMp",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToMt",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"amount",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToMu",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32",
                "name":"itemId",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"itemNum",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToToken1155",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"amount",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToToken20",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"itemToToken721",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"maToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32",
                "name":"itemId",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"itemNum",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"mabToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32",
                "name":"itemId",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"itemNum",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"mbbToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"amount",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"mgToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"mhToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"mpToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"mtToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"amount",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"muToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            },
            {
                "internalType":"uint256[]",
                "name":"",
                "type":"uint256[]"
            },
            {
                "internalType":"uint256[]",
                "name":"",
                "type":"uint256[]"
            },
            {
                "internalType":"bytes",
                "name":"",
                "type":"bytes"
            }
        ],
        "name":"onERC1155BatchReceived",
        "outputs":[
            {
                "internalType":"bytes4",
                "name":"",
                "type":"bytes4"
            }
        ],
        "stateMutability":"pure",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            },
            {
                "internalType":"bytes",
                "name":"",
                "type":"bytes"
            }
        ],
        "name":"onERC1155Received",
        "outputs":[
            {
                "internalType":"bytes4",
                "name":"",
                "type":"bytes4"
            }
        ],
        "stateMutability":"pure",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"contract Bep1155",
                "name":"sc",
                "type":"address"
            }
        ],
        "name":"setBep1155",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"contract Bep20",
                "name":"sc",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"target",
                "type":"address"
            }
        ],
        "name":"setBep20",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"contract Bep721",
                "name":"sc",
                "type":"address"
            }
        ],
        "name":"setBep721",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"addr",
                "type":"address"
            }
        ],
        "name":"setOwner",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint256",
                "name":"v",
                "type":"uint256"
            }
        ],
        "name":"setTransTimeout",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"addr",
                "type":"address"
            }
        ],
        "name":"setVerifier",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"bytes4",
                "name":"",
                "type":"bytes4"
            }
        ],
        "name":"supportsInterface",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"pure",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32",
                "name":"itemId",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"itemNum",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"token1155ToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint64",
                "name":"amount",
                "type":"uint64"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"token20ToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            },
            {
                "internalType":"uint32",
                "name":"ts",
                "type":"uint32"
            },
            {
                "internalType":"uint32[]",
                "name":"itemId",
                "type":"uint32[]"
            },
            {
                "internalType":"uint8",
                "name":"v",
                "type":"uint8"
            },
            {
                "internalType":"bytes32",
                "name":"r",
                "type":"bytes32"
            },
            {
                "internalType":"bytes32",
                "name":"s",
                "type":"bytes32"
            }
        ],
        "name":"token721ToItem",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            }
        ],
        "name":"unlockUserNonce",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"user",
                "type":"address"
            },
            {
                "internalType":"uint8",
                "name":"flag",
                "type":"uint8"
            }
        ],
        "name":"userNonce",
        "outputs":[
            {
                "internalType":"uint64",
                "name":"",
                "type":"uint64"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    }
];

let mhNftContract = null;
let mbbNftContract = null;
let marketContract = null;
let mgTokenContract = null;
let gameContract = null;
let muContract = null;

export function setNFTAddress(data) {
   MH_NFT_ADDRESS = data.mhNFTAddress;
   MBB_NFT_ADDRESS = data.mbbNFTAddress;
   MG_TOKEN_ADDRESS = data.mgTokenAddress;
   MARKET_ADDRESS = data.marketAddress;
   GAME_ADDRESS = data.gameAddress;
   MU_ADDRESS = data.muAddress;
}

export function getNFTAddress() {
  return{
    'MH_NFT_ADDRESS':  MH_NFT_ADDRESS,
    'MBB_NFT_ADDRESS': MBB_NFT_ADDRESS,
    'MG_TOKEN_ADDRESS': MG_TOKEN_ADDRESS,
    'MARKET_ADDRESS': MARKET_ADDRESS,
    'GAME_ADDRESS': GAME_ADDRESS,
    'MU_ADDRESS': MU_ADDRESS
  }
}

export function setChainParams(data) {
   gChainParams[0] = data;
}

export function getChainParams() {
  return gChainParams[0];
}

export function setContracts(contracts) {
  mhNftContract = contracts.mhNftContract;
  mbbNftContract = contracts.mbbNftContract;
  marketContract = contracts.marketContract;
  mgTokenContract = contracts.mgTokenContract;
  gameContract = contracts.gameContract;
  muContract = contracts.muContract;
}

export function getContracts() {
  return {
    'mhNftContract':  mhNftContract,
    'mbbNftContract': mbbNftContract,
    'marketContract': marketContract,
    'mgTokenContract': mgTokenContract,
    'gameContract': gameContract,
    'muContract': muContract
  }
}
